import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box } from "@mui/material";
import Logo from "../../assets/images/logo.png";
import { Badge } from "./formParts";
import { Icon, T } from "./signupDesign";

// Same height as the site header it replaces, so the page offsets still fit.
export const PARTNER_HEADER_HEIGHT = 64;

const roleLabel = (role) => (role === "ADMIN" ? "Super admin" : "Agent");

/**
 * The sign-up pages' own header: the logo, and on the right who is filling
 * the application in (staff) or how to reach us. No ordering controls
 * (address, cart, account): this page isn't for ordering, and staff often
 * open it in a browser logged in as a customer.
 */
export default function PartnerHeader({ staff }) {
  return (
    <Box
      component="header"
      sx={{ position: "fixed", top: 0, left: 0, right: 0, height: PARTNER_HEADER_HEIGHT, zIndex: 1100, background: "#fff", borderBottom: `1px solid ${T.cardBorder}` }}
    >
      <Box sx={{ maxWidth: 1240, mx: "auto", px: { xs: 2, sm: 4 }, height: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
        <Box
          component={RouterLink}
          to="/"
          aria-label="RushMyFood home"
          sx={{ display: "flex", alignItems: "center", flexShrink: 0, borderRadius: "10px", "&:focus-visible": { outline: "none", boxShadow: T.focusRing } }}
        >
          <img src={Logo} alt="" style={{ height: 40, objectFit: "contain" }} />
        </Box>
        {staff ? (
          <Box
            aria-label={`Filling in as ${staff.name}, ${roleLabel(staff.role)}`}
            sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, border: `1px solid ${T.cardBorder}`, background: T.footerBg, borderRadius: 999, pl: 1.25, pr: 0.75, py: 0.5 }}
          >
            <Box aria-hidden="true" sx={{ display: "flex", color: T.muted }}><Icon.User size={18} /></Box>
            <Box component="span" aria-hidden="true" sx={{ display: { xs: "none", sm: "inline" }, color: T.muted, fontSize: 14, whiteSpace: "nowrap" }}>Filling in as</Box>
            <Box component="span" aria-hidden="true" sx={{ fontWeight: 600, fontSize: 14, color: T.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}>
              {staff.name}
            </Box>
            <Box aria-hidden="true" sx={{ flexShrink: 0 }}><Badge kind={staff.role === "ADMIN" ? "required" : "optional"}>{roleLabel(staff.role)}</Badge></Box>
          </Box>
        ) : (
          <Box
            component="a"
            href="mailto:info@rushmyfood.com"
            sx={{ display: "flex", alignItems: "center", gap: 1, minHeight: 44, px: 1, color: T.text2, fontSize: 14, fontWeight: 600, textDecoration: "none", borderRadius: 999, "&:hover": { color: T.linkHover }, "&:focus-visible": { outline: "none", boxShadow: T.focusRing } }}
          >
            <Icon.Mail size={18} />
            <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>Questions? info@rushmyfood.com</Box>
            <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>Help</Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}
